@if (workLine) {
  <div
    class="work-line expand-panel"
    [class.work-line-selected]="workLine.isSelected"
    [ngStyle]="{ 'padding-left.px': getIndentation(), 'padding-right.px': 39 }"
  >
    <div class="work-line-details object-border">
      <div class="line-title line-column title">
        <span class="description-text">{{ workLine.description }}</span>
        <div class="tags">
          <span class="property-tag"
            >{{ 'workOrderObject.progressType' | translate }}: {{ workLine.progressType }}</span
          >
          <span class="property-tag">Work Type: {{ workLine.workType }}</span>
        </div>
      </div>
      <div class="work-line-quantity work-line-progress">
        <div class="line-planned-quantity line-column">
          <span class="numeric-value">Planned Len: {{ workLine.plannedQuantity }}</span>
          <span class="material-unit">{{ workLine.unit }}</span>
        </div>
        <div class="line-installed-quantity line-column" (click)="showCableDialog(workLine)">
          <span class="numeric-value"
            >Pulled Len: {{ workLine.installedQuantity ? workLine.installedQuantity : 0 }}</span
          >
          <span class="material-unit">{{ workLine.unit }}</span>
        </div>
      </div>
      <!--      <div class="line-action">-->
      <!--        <button mat-flat-button color="primary" (click)="markAsComplete(workLine)" *ngIf="!workLine.completed">-->
      <!--          {{ 'workOrderLines.lineComplete' | translate }}-->
      <!--        </button>-->
      <!--        <div class="line-done" *ngIf="workLine.completed" (click)="markAsReopened(workLine)">-->
      <!--          <i class="material-icons icon">done</i>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="work-line-select">
        @if (!workLine.completed) {
          <mat-checkbox
            class="mat-checkbox-xl"
            [checked]="workLine.isSelected"
            (click)="markAsComplete(workLine)"
            (change)="toggleSelectedWorkLine(workLine)"
          >
          </mat-checkbox>
        }
        @if (workLine.completed) {
          <div class="line-done" (click)="markAsReopened(workLine)">
            <i class="material-icons icon">done</i>
          </div>
        }
      </div>
      <div class="object-expand"></div>
    </div>
  </div>
}
